import type {Conversation} from "@repo/guide-types";

/**
 * Flag incoming messages if the outgoing message was flagged.
 *
 * @param conversation The conversation to filter.
 * @returns The filtered conversation.
 */
export const filterFlaggedQuestionResponses = (
    conversation: Conversation,
): Conversation =>
    conversation.reduce<Array<any>>( // We don't want to show responses from the AI if the user's question has
        // been flagged. To do this we mark the server's response as flagged so that
        // we don't show it to the user.
        (acc, message, i, originalArray) => {
            const prevMessage = i > 0 ? originalArray[i - 1] : null;
            if (
                prevMessage?.type === "outgoing" &&
                prevMessage.contentFlagged &&
                message.type === "incoming"
            ) {
                acc.push({...message, contentFlagged: true});
            } else {
                acc.push(message);
            }
            return acc;
        },
        [],
    );
